import { render, staticRenderFns } from "./b-ticket-travel-insurance-trip-details.vue?vue&type=template&id=a0f80f2a&scoped=true"
import script from "./b-ticket-travel-insurance-trip-details.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket-travel-insurance-trip-details.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket-travel-insurance-trip-details.vue?vue&type=style&index=0&id=a0f80f2a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f80f2a",
  null
  
)

export default component.exports